import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Table} from 'antd';
import Card from "components/card";
import CrudOption from "components/dropdown/crudoption";
import { 
	getEmployeeScheduleList, doEmployeeScheduleDelete, 
	doEmployeeScheduleReset 
} from "../../../../../redux/employeeschedule/employeeScheduleState";
import { handleTableChange } from "../../../../../utils/index";
import PopupButton from "components/button/PopupButton";
import ScheduleForm from "./ScheduleForm";

const ScheduleTable = ({employeeId}) => {
	const dispatch = useDispatch();

	const recordList = useSelector((state) => state.employeeSchedule.employeeScheduleList?.items);
	const pagination = useSelector((state) => state.employeeSchedule.employeeScheduleList?.pagination);
	const filters = useSelector((state) => state.employeeSchedule.employeeScheduleList?.filters);

	const doDelete = (id) => dispatch(doEmployeeScheduleDelete(id));
	const doRecordReset = () => dispatch(doEmployeeScheduleReset());
	const doSearch = (filters) => dispatch(getEmployeeScheduleList(filters));

  	const columns = [
	    {
	        title: `Effective Date`,
	        dataIndex: 'esd_effective_date_from',
	        key: 'esd_effective_date_from',
	        width: '66%',
	        render: (esd_effective_date_from, record) => <span>{`${esd_effective_date_from ?? ''}`} to {`${record?.esd_effective_date_to ?? 'Present'}`}</span> 
	    },
		{
	        title: `Schedule Template`,
	        dataIndex: 'template_title',
	        key: 'template_title',
	        width: '22%',
	        render: (template_title, record) => <span>{template_title ?? "Custom Schedule"}</span> 
	    },
	    {
	        title: (
				<div className="flex justify-center">
					<PopupButton id="add_employee_schedule" title="Add Schedule" label="Add" btnClass="btn-small">
						<ScheduleForm recordId={0} mode="edit" employeeId={employeeId} />
					</PopupButton>
				</div>
			),
	        dataIndex: 'esd_id',
	        key: 'esd_id',
	        width: '12%',
	        render:(_, record) => <CrudOption 
										baseRoute={`/console/employees/${employeeId}/employee-schedules`} 
										recordId={record?.esd_id} 
										allowView={false} 
										deleteHandler={() => doDelete({
											esd_employee_id: record?.esd_employee_id,
											esd_id: record?.esd_id,
										})} 
										editMode="modal"
										title="Edit Schedule"
										closeHandler={doRecordReset}
										editHandler={(recordId, doRecordReset) => (
											<ScheduleForm 
												recordId={recordId} 
												employeeId={employeeId} 
												mode="edit" 
												onCancel={doRecordReset} 
											/>
										)}
									/>
	    },
    ];

	useEffect(() => {
		if (employeeId) {
			dispatch(getEmployeeScheduleList({
				paginate: pagination?.per_page ?? 10,
				employeeId,
			}));
		}
	}, [dispatch, employeeId, pagination?.per_page]);
	
  	return (
	    <Card extra={"w-full h-full p-4"}>
	      	<div className="h-full overflow-x-auto xl:overflow-x-hidden">
	      		<Table 
		        	dataSource={recordList} 
		        	columns={columns} 
		            rowKey={(record) => record.esd_id}
					scroll={{ x: "max-content" }}
		        	pagination={{...pagination, showTotal: (total, range) => `${range[0]} - ${range[1]} of ${total} records`,}}    
		            onChange={handleTableChange(doSearch, filters)}    
	        	/>
	      	</div>
	    </Card>
  );
};

export default ScheduleTable;